import type { RequestConfig } from '@customTypes/index';
import type { WorkItemDto, WorkItemStatus } from '@customTypes/types';
import qs from 'qs';

import { api } from '@/shared/api/instance';

export type ArtistWorkItemsListRequest = {
  profileId: string;
  status?: WorkItemStatus[] | WorkItemStatus;
};

export type ArtistWorkItemsListParams =
  RequestConfig<ArtistWorkItemsListRequest>;

export const artistWorkItemsList = async ({
  params,
  config
}: ArtistWorkItemsListParams) =>
  api.get<WorkItemDto[]>(`/api/work/items/artist/${params.profileId}`, {
    ...config,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
    params: {
      status: params.status
    }
  });
